import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApproveRejectComponent } from './components/approve-reject/approve-reject.component';
import { CancelComponent } from './components/cancel/cancel.component';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ResetSuccessComponent } from './components/reset-success/reset-success.component';
import { CancelDeletionComponent } from './components/cancel-deletion/cancel-deletion.component';
import { DeleteAccountComponent } from './components/delete-account/delete-account.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule} from '@angular/forms';
import { DownloadPosterComponent } from './components/download-poster/download-poster.component';
import { MatIconModule } from '@angular/material/icon';
@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatDividerModule,
    MatSlideToggleModule,
    MatChipsModule,
    MatRadioModule,
    FormsModule,
    MatIconModule
  ],
  declarations: [
    ApproveRejectComponent,
    CancelComponent,
    ResetSuccessComponent,
    CancelDeletionComponent,
    DeleteAccountComponent,
    DownloadPosterComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedContainerModule { }
